import styled from 'styled-components';
import zIndex from '../../constants/zIndex';
import { fadeOut } from '../../constants/keyframes/fades';

const StyledEntryMask = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background: #fff;
	z-index: ${zIndex.entryMask};
	animation: ${fadeOut} 600ms linear forwards;
	pointer-events: none;
`;

export default StyledEntryMask;
